import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';


const API_URL = 'https://localhost:44337/api/CustomerApi';

const CustomerEdit = ({ match }) => {
  const history = useHistory();
  const recordId = match.params.id;
  const { id } = useParams();
  //const { isAuthenticated, companyId, userId } = useAuth();
  const { isAuthenticated, companyId, userId, token, logout } = useAuth();
  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }
  }, [isAuthenticated, companyId, token, logout]);

  const [formData, setFormData] = useState({});

  //customer type

  const [selectedCustomerWarrantyOptions, setSelectedCustomerWarrantyOptions] = useState("");
  const [customerWarrantyOptionsOptions, setCustomerWarrantyOptionsOptions] = useState([]);
  const [selectedCustomerWarrantyOptionsType, setSelectedCustomerWarrantyOptionsType] = useState("");

  const fetchCustomerWarrantyOptions = async () => {
    try {
      const response = await fetchData('ServiceRequestTypeApi', `/${companyId}`);
      if (response.responseCode === '1111') {

        const options = response.response_data.map(customer => ({
          value: customer.id,
          label: customer.status
        }));
        setCustomerWarrantyOptionsOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Customer Types:', error);
    }
  };

  // const handleCustomerWarrantyChange = (selectedOption) => {
  //   setSelectedCustomerWarrantyOptionsType(selectedOption);
  // };

  useEffect(() => {
    fetchCustomerWarrantyOptions();
  }, []);

  const handleCustomerTypeChange = (selectedOption) => {
    setSelectedCustomerType(selectedOption);
    setFormData((prevData) => ({
      ...prevData,
      CustomerTypeID: selectedOption ? parseInt(selectedOption.value) : null, // Ensure it's a number
    }));
  };

  const handleCustomerWarrantyChange = (selectedOption) => {
    setSelectedCustomerWarrantyOptionsType(selectedOption); // Update state for display
    setFormData((prevData) => ({
      ...prevData,
      AMC: selectedOption ? selectedOption.value : null, // Update formData with selected ID
    }));
  };


  useEffect(() => {
    fetchData('CustomerApi', `/CustomerEdit/${id}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setFormData(response.response_data);
          console.log(response);
        }
      })
      .catch((error) => {
        console.error('Error fetching Location Details:', error);
      });
  }, [id]);

  const [selectedAMC, setSelectedAMC] = useState("1");


  // const handleChange = event => {

  //   const { name, value, type, checked } = event.target;
  //   setSelectedAMC(event.target.value);
  //   setFormData(prevData => ({
  //     ...prevData,
  //     [name]: type === 'checkbox' ? checked : value,
  //     UpdatedBy: userId,
  //     customerWarrantyId: selectedCustomerWarrantyOptionsType.value,
  //   }));
  // };

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   setIsLoading(true);
  //   setFormData(prevData => ({
  //     ...prevData,
  //   }));


  //   updateData('CustomerApi', `${id}`, formData, token)
  //     .then((response) => {
  //       console.log('Record updated successfully:', response.data);
  //       history.push('/CustomerIndex');
  //     })
  //     .catch((error) => {
  //       console.error('Error updating record:', error);
  //       setIsLoading(false);
  //     });
  // };


  //customer type
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [customerTypeOptions, setCustomerTypeOptions] = useState([]);
  const [selectedCustomerType, setSelectedCustomerType] = useState("");

  const fetchCustomerTypes = async () => {
    try {
      const response = await fetchData('CustomerTypeApi', `/${companyId}`);
      if (response.responseCode === '1111') {

        const options = response.response_data.map(customer => ({
          value: customer.type,
          label: customer.type
        }));
        setCustomerTypeOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Customer Types:', error);
    }
  };
  // const handleCustomerTypeChange = (selectedOption) => {
  //   setSelectedCustomerType(selectedOption);
  // };

  useEffect(() => {
    fetchCustomerTypes();
  }, []);


  const [isLoading, setIsLoading] = useState(false);


  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
      UpdatedBy: userId,
      customerWarrantyOptionEdit : selectedCustomerWarrantyOptionsType.label,
      customertypeOptionEdit : selectedCustomerType.label
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);

    // Prepare the form data for submission
    const updatedFormData = {
      ...formData,
      UpdatedBy: userId, // Ensure userId is set correctly
      customerWarrantyOptionEdit : selectedCustomerWarrantyOptionsType.label,
      customertypeOptionEdit : selectedCustomerType.label
    };

    updateData('CustomerApi', `${id}`, updatedFormData, token)
      .then((response) => {
        console.log('Record updated successfully:', response.data);
        history.push('/CustomerIndex');
      })
      .catch((error) => {
        console.error('Error updating record:', error);
        setIsLoading(false);
      });
  };
  

  return (
    <div className="w-full max-w-sm container mt-6 mx-auto">
      <form onSubmit={handleSubmit}>
        <div className='w-full mb-2 flex items-center'>
          <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>CUSTOMER EDIT</h6>

          <Tooltip title="Exit">
            <Link to="/CustomerIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
              <Button style={{ color: 'brown', fontWeight: 'bolder' }}>
                Back To List <ArrowForwardIosIcon />
              </Button>
            </Link>
          </Tooltip>

          <Tooltip title="Update">

            <Button onClick={handleSubmit} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
              {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} <CheckCircleIcon />
            </Button>

          </Tooltip>

        </div>


        <div className="w-full mb-4 flex">
          <div className="w-1/4 mr-2">
            <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
              Customer Type
            </label>

            {/* <Select
              value={selectedCustomerType || (formData.customertype ? { value: formData.customerTypeID, label: formData.customertype } : '')}
              onChange={handleCustomerTypeChange}
              options={customerTypeOptions}
              placeholder="Customer-Type"
              isSearchable
            /> */}
            <Select
              value={selectedCustomerType || (formData.customertype ? { value: formData.customerTypeID, label: formData.customertype } : '')}
              onChange={handleCustomerTypeChange}
              options={customerTypeOptions}
              placeholder="Customer-Type"
              isSearchable
            />
          </div>
          <div className="w-1/4 mr-2">
            <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '14px' }}>
              Name
            </label>

            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="customerName"
              value={formData.customerName}
              onChange={handleChange}
              type="text"
              placeholder="Enter Name"
            />
          </div>

          {/* {selectedCustomerType && (selectedCustomerType.label === 'IGST' || selectedCustomerType.label === 'B to B') && ( */}

          <div className="w-1/4 mr-2">
            <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '14px' }}>
              Contact Person
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              value={formData.contactPerson}
              onChange={handleChange}
              type="text"
              placeholder="Contact person"
              name="contactPerson"
            />
          </div>
          {/* )} */}

          <div className="w-1/4 mr-2">
            <label className="block tracking-wide text-black text-base  mb-2" htmlFor="contactNumber1">
              Contact Number 1
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="contactNumber1"
              value={formData.contactNumber1}
              onChange={handleChange}
              type="text"
              placeholder="Enter Contact Number 1"
            />
          </div>
          <div className="w-1/4 mr-2">
            <label className="block tracking-wide text-black text-base  mb-2" htmlFor="contactNumber1">
              Contact Number 2
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name='contactNumber2'
              value={formData.contactNumber2}
              onChange={handleChange}
              type="text"
              placeholder="Enter Contact Number 1"
            />
          </div>
        </div>

        <div className="w-full mb-4 flex">
          {/* {selectedCustomerType && (selectedCustomerType.label === 'IGST' || selectedCustomerType.label === 'B to B') && ( */}
          <div className="w-1/4 mr-2">
            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="gstNumber">
              GST Number
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              value={formData.gstNumber}
              name='gstNumber'
              onChange={handleChange}
              maxLength={15} type="text"
              placeholder="GST Number" />

          </div>
          {/* )} */}
          <div className="w-1/2 mr-2">
            <label className="block  tracking-wide text-black text-base mb-2" htmlFor="AddressLine1">
              Address Line 1
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="addressLine1"
              value={formData.addressLine1}
              onChange={handleChange}
              type="text"
              placeholder="Enter Address Line 2"
            />
          </div>

          <div className="w-1/2 mr-2">
            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="AddressLine2">
              Address Line 2
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="adressLine2"
              value={formData.adressLine2}
              onChange={handleChange}
              type="text"
              placeholder="Enter Address Line 2"
            />
          </div>

        </div>
        <div className="w-full mb-4 flex">

          <div className="w-1/2 mr-2">
            <label className="block  tracking-wide text-black text-base mb-2" htmlFor="LandMark">
              LandMark
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="landMark"
              value={formData.landMark}
              onChange={handleChange}
              type="text"
              placeholder="Enter Town"
            />
          </div>
          <div className="w-1/2 mr-2">
            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="Town">
              Town
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="town"
              value={formData.town}
              onChange={handleChange}
              type="text"
              placeholder="Enter Town"
            />
          </div>

          <div className="w-1/2 mr-2">
            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="District">
              District
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="district"
              value={formData.district}
              onChange={handleChange}
              type="text"
              placeholder="Enter District"
            />
          </div>

          <div className="w-1/2 mr-2">
            <label className="block  tracking-wide text-black text-base mb-2" htmlFor="State">
              State
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="state"
              value={formData.state}
              onChange={handleChange}
              type="text"
              placeholder="Enter State"
            />
          </div>

        </div>
        <div className="w-full mb-4 flex flex-wrap">
          <div className="w-full md:w-1/6 mr-2">
            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
              Customer Warranty Options
            </label>
            {/* <Select
              value={selectedCustomerWarrantyOptionsType || (formData.amCwarranty ? { value: formData.amc, label: formData.amCwarranty } : '')}
              // value={selectedCustomerWarrantyOptionsType}
              onChange={handleCustomerWarrantyChange}
              options={customerWarrantyOptionsOptions}
              placeholder="Warranty Options"
              isSearchable
            /> */}
            <Select
              value={selectedCustomerWarrantyOptionsType || (formData.amCwarranty ? { value: formData.amc, label: formData.amCwarranty } : '')}
              onChange={handleCustomerWarrantyChange}
              options={customerWarrantyOptionsOptions}
              placeholder="Warranty Options"
              isSearchable
            />
          </div>


          <div className="w-full md:w-1/6 mr-2">
            <label
              className="block tracking-wide  text-xs mb-2"
              htmlFor="toDate"
              style={{ fontSize: '15px', fontWeight: 'bold', color: 'red' }}
            >
              Warranty Expired Date
            </label>
            <input
              type="date"
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
              value={formData.warrentyExpireDate ? formData.warrentyExpireDate.split('T')[0] : ''}
              onChange={handleChange}
              name='warrentyExpireDate'
            />
          </div>
          <div className="w-full md:w-1/2 mr-2">
            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
              Remark
            </label>
            <textarea
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              value={formData.customerRemark}
              onChange={handleChange}
              name='customerRemark'
              placeholder="Enter Remarks"
              rows={3}
              maxLength={250}
            />
          </div>
        </div>

      </form>
    </div>

  );
};

export default CustomerEdit;
